import React from "react";
import { Box } from "@bca/ui-library";

const SalesResultsContainer: React.FC = (props) => {
  return (
    <Box
      maxWidth={["calc(100% - 32px)", "calc(100% - 48px)", 976]}
      margin="0 auto"
    >
      {props.children}
    </Box>
  );
};

export default SalesResultsContainer;
